import React from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import uuid from '../../../../core/components/UniqueHash';
import { useModal } from '../../../../../../hooks/Modal';
import FormComponent, { sanitizeDataObject } from '../../../../core/components/FormComponentUnique';
import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';
import getValidationErrors from '../../../../../../utils/getValidationErrors';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import { AxiosInstance } from 'axios';
import { FaPlus, FaUpload, FaIdBadge, FaTrophy } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../../../../hooks/Auth';
import { FiX } from 'react-icons/fi';

interface ICreateModule {
  lineData: Record<string, any>;
}

interface IParams {
  projectHash: string;
  eventHash: string;
}

export default function CreateModule(): JSX.Element {
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();
  const { projectHash, eventHash } = useParams<IParams>();
  const { user } = useAuth();
  const key = uuid();



  const showChange = async (data) => {

    const selectiveProcess = await api.get('/selective-process', { params: { limitItems: 10000, where: { project_id: projectHash } } })
    const students = await api.get('/students', { params: { limitItems: 100000  } });

const list : Array<Record<string,any>> = [];

data?.map(item => {


  const student = students?.data?.rows?.find(i => i?.document_number === item?.CPF?.toString()?.trim()?.replace(/[^0-9]/g, ''));
  const selective = selectiveProcess?.data?.rows?.find( i => i?.client_id === student?._id?.toString());

  list.push({
    _id: selective?._id?.toString(),
    category: selective?.category,
    area: selective?.area,
    subarea : selective?.subarea,
    name: student?.name,
    grade: item?.NOTA,
    status: 'register',
    register_position_number : item?.POSICAO,
    register_position : item?.RESULTADO,


  })


})



    const content = (
      <>
        <p style={{ color: '#333' }}>Processos seletivos"</p>
        <p style={{ color: '#333' }}> {list?.length} registros</p>
        <button className='greenButton2' onClick={() => updateData(list)}>Confirmar atualização?</button>

        <table className='tableRef'>
          <tbody>
            <tr><td>NOME</td><td>CATEGORIA</td><td>ÁREA</td><td>SUBÁREA</td><td>STATUS</td><td>POSIÇÃO</td><td>CLASSIFICAÇÃO</td></tr>
            {list?.map(i => {
              return <tr><td>{i?.name}</td><td>{i?.category}</td><td>{i?.area}</td>
                <td>{i?.subarea}</td><td>{i?.status}</td><td>{i?.register_position_number}</td><td>{i?.register_position}</td></tr>
            })}
          </tbody>
        </table>

      </>
    );
    if (content) {
      const keyModal = addModal({ title: 'Atualizar processos', content, key, theme: "whiteModal" });
    }
  };

  const setCallback = async (
    data: Record<string, any>,
    formRef: React.RefObject<FormHandles>,
  ): Promise<void> => {
    try {
      const formData = new FormData();
      formData.append('file', data.image)
    
      const response = await api.post(`/converter/xlsx-to-json`, formData);

      if (response.status !== 200) {
        return addToast({ type: 'error', title: 'Gerar' });
      }

      showChange(response?.data?.rows)
  

    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);
        return;
      }

      return addToast({ type: 'error', title: err?.response?.data?.error || err?.response?.data?.message });
    }
  };

  const handleCreate = (): void => {
    const content = (
      <FormComponent schema={{
        image: {
          model: 'uploadImage',
          type: 'upload',
          name: 'image',
          label: 'Excel',
        }
      }} setCallback={setCallback} />
    );
    if (content) {
      const keyModal = addModal({ title: 'Atualizar processos', content, key, theme: "whiteModal" });
    }
  };


  const updateData = async (data) => {

    data.map(async (item, index) => {


      await api.put(`/selective-process/${item?._id?.toString()}/status`, { status: item?.status })
      await api.put(`/selective-process/${item?._id?.toString()}/register_position`, { register_position: item?.register_position })
      await api.put(`/selective-process/${item?._id?.toString()}/register_position_number`, { register_position_number: item?.register_position_number })
      addToast({ title: `${item?.client_id_response?.name} - ${index + 1} / ${data?.length}` })
    })
  }


  

  const moduleCreate = (): JSX.Element => (
    user && user?.profile === 1 ? <><button className="searchButton" type="button" onClick={handleCreate}>
      <FaTrophy title='Avançar para matrículas' color='green' />
    </button>
     

    </>
      : <></>
  );

  return moduleCreate();
}
